<script lang="ts">
  	import { createEventDispatcher } from 'svelte'
    import { exerciseIDsStore } from "../stores/exerciseIDsStore"
    import { exerciseDatasStore } from "../stores/exerciseDatasStore"
    import { userExerciseDataStore } from '../stores/userExerciseDataStore'

    const dispatch = createEventDispatcher<{accept:string, cancel:void}>()
    export let selectedExerciseID:string
</script>

<div class="h-full flex flex-col bg-darkBack">
  <div class="text-darkFore">Table of Contents</div>
  <select class="flex-1 bg-darkBack" size="{$exerciseDatasStore.values.size}" bind:value="{selectedExerciseID}">
    {#each $exerciseIDsStore as exerciseID}
    <option value="{exerciseID}">{($userExerciseDataStore[exerciseID]?.completed ? "😊 " : "◯ ") + $exerciseDatasStore.get(exerciseID).name}</option>
    {/each}
  </select>
  <div class="flex flex-row">
    <button class="btn-darkBackHigh flex-1" on:click={() => {dispatch('cancel')}}>Cancel</button>
    <button class="btn-darkBackHigh flex-1 text-orange" on:click={() => {dispatch('accept', selectedExerciseID)}}>OK</button>
  </div>
</div>

<style>
  option {
    @apply border-none;
    @apply outline-none;
    @apply bg-darkBack;
    @apply text-darkFore
  }

  option:checked {
    @apply text-darkFore;
    @apply bg-lightBackHigh;
  }

  option:hover {
    @apply bg-darkBackHigh;
  }
</style>